module.exports = __webpack_public_path__ + "static/danielebossari-427afd9b70bb24bd904f7aa1d56ad27d.png";